<script setup lang="ts">
import { RefreshCw } from 'lucide-vue-next'

const { refreshing, size = 5 } = defineProps<{
  refreshing: boolean
  size?: number
}>()
</script>

<template>
  <Button :loading="refreshing" class="bg-transparent" text>
    <template #default>
      <RefreshCw
        :class="[refreshing ? 'animate-spin' : '', 'size-' + size]"
      />
    </template>
  </Button>
</template>
